import styled from '@emotion/styled'
import { darken, Link, Theme, useTheme } from '@mui/material'

const StyledLink = styled(Link)<{ theme: Theme }>`
  transition: color 150ms ease-in-out;

  ${({ theme }) => `
    &:hover {
      color: ${darken(theme.palette.primary.main, 0.3)};
      transition: color 150ms ease-in-out;
    }
  `}
`

interface Props {
  href: string
}

export const LearnMoreLink = ({ href }: Props) => {
  const theme = useTheme()
  return (
    <StyledLink theme={theme} underline="none" href={href} target="_blank" rel="noopener">
      Learn more
    </StyledLink>
  )
}
